<template>
  <div class="privacy">
    <div class="header">
      <div @click="LinkFn(item.path)" v-for="item in navBarList">{{item.name}}</div>
    </div>
    <div class="content">
      <div class="tabBar">
        <div :class="{active: index==active}" v-for="(item,index) in tabList" @click="changeFn(index)">
          {{item.title}}</div>
      </div>
      <div class="txt" v-if="active==0">
        <div><b>TEWA MOTO APP User Agreement</b></div>
        <div>Welcome to use TEWA MOTO products and TEWA MOTO APP.</div>
        <div>
          This agreement is concluded between you and 
          <b>
            TEWA MOTO Inc. for the registration and use of the TEWA MOTO account. TEWA MOTO Inc. (hereinafter referred
            to as "TEWA MOTO") hereby reminds you in particular Carefully read and fully understand the terms of this
            agreement, the terms exempting or limiting TEWA MOTO’s liability, the terms limiting your rights, dispute
            resolution, and applicable laws, etc.
          </b>
          Please read it carefully and choose to accept or not accept this agreement (a person with limited civil
          capacity should read it with a guardian or legal representative). 
          <b>Unless you accept all the terms of this
            agreement, you have no right to register and use an TEWA MOTO account. Your registration and use of the TEWA
            MOTO account will be deemed that you have fully understood this agreement (that is, this agreement and
            subsequent updated versions or a single agreement for opening or using a certain service), and agree to be
            bound by the terms of this agreement.</b>
        </div>
        <div>
          <b>About TEWA MOTO Account</b>
        </div>
        <div>
          The TEWA MOTO account is an identifier owned by TEWA MOTO used to identify you. The ownership of the account
          belongs to TEWA MOTO. As the initial registrant, you only have the right to use the account you registered.
        </div>
        <div>
          <b>Account usage rules</b>
        </div>
        <div>
          1. Register an account
        </div>
        <div>
          You should provide timely, detailed, and accurate personal information, and constantly update the registration
          information to meet the timely, detailed, and accurate requirements. You guarantee that all the information
          submitted during registration (including but not limited to the mobile phone number, email address, etc.) is
          true, accurate, legal, valid, and is your information. If the registration information is untrue or not
          updated in time, TEWA MOTO will not be responsible for any related problems. You can inquire and correct your
          information through the account settings page of TEWA MOTO. The registered information such as the account
          name, avatar, and profile submitted by you shall not contain illegal or undesirable information. After
          verification by TEWA MOTO, TEWA MOTO will not register if the above conditions exist. ; At the same time,
          after registration, if it is found that you have fraudulently obtained the account name registered with false
          information, or your account picture, profile and other registration information contains illegal and
          undesirable information, Le Bank has the right to take corrective action, suspend use, Measures such as
          account termination. After you fill in the information as prompted on the registration page, read and agree to
          the terms of this agreement, and complete all registration procedures, you can obtain an TEWA MOTO account and
          become an TEWA MOTO APP user
        </div>
      </div>
      <div class="txt" v-if="active==1">
        <div><b>TEWA MOTO APP privacy policy</b></div>
        <div>This policy is only applicable to TEWA MOTO APP service of TEWA MOTO Inc.  Last updated: October 8, 2021
        </div>
        <div>This policy will help you understand the following:</div>
        <div>Ⅰ. How do we collect and use your user information</div>
        <div>Ⅱ. How do we use cookies and similar technologies</div>
        <div>Ⅲ. How do we share, transfer and publicly disclose your user information</div>
        <div>Ⅳ. How do we protect your user information</div>
        <div>Ⅴ. Your rights</div>
        <div>Ⅵ. How do we handle children's personal information</div>
        <div>Ⅶ. How is your user information stored and transferred globally</div>
        <div>Ⅷ. How is this policy updated</div>
        <div>Ⅸ. How to contact us</div>
        <div>We are well aware of the importance of user information to you and will do our best to protect the security
          and reliability of your user information. We are committed to maintaining your trust in the US and abide by
          the following principles to protect your user information: the principle of consistent rights and
          responsibilities, the principle of clear purpose, the principle of choice and consent, the principle of
          minimum adequacy, the principle of ensuring security, the principle of subject participation, the principle of
          openness and transparency, etc. At the same time, we promise that we will take corresponding security measures
          to protect your user information according to the mature security standards in the industry.</div>
        <div>Please read and understand this privacy policy carefully before using our products (or services).</div>
        <div><b>Ⅰ. How do we collect and use your user information</b></div>
        <div>（1） The information we collect and use when you use our products or services
          We will only collect and use your user information for the business functions described in this policy. The
          purpose of collecting user information is to provide you with products or services. You have the right to
          choose whether to provide this information. However, in most cases, if you do not provide it, we may not be
          able to provide you with corresponding services or respond to your problems.</div>
        <div>When you use our services, we may collect the following types of information (either personal or not):
        </div>
        <div>Information you created or provided to us:</div>
        <div>When you create an TEWA MOTO account, you provide us with your user name, password, mobile phone number,
          email, nickname, images you choose to represent yourself, etc.</div>
        <div>We also collect content you create, upload, save or receive when using our social services. This includes
          the text you saved and uploaded, the photos and videos you uploaded, your comments on other people's posts or
          other people's comments on your posts, your publishing location, the virtual DIY lighting and sound effects
          you uploaded, etc.</div>
        <div>Information you collect when using our products and services:</div>
        <div>• device information: information related to your device. For example, <b>IMEI number, MAC address (Android
            version only), device model name, device operating system, device type, system and performance information,
            device manufacturer information, and network operator, we may collect and use information such as TEWA MOTO
            account.</b></div>
        <div>
          • product information: information related to our products you purchased. For example, <b>the product's
            Bluetooth / WiFi MAC address, serial number, and product usage data such as speed and mileage.</b>
        </div>
        <div>
          • location information (only applicable to specific services/functions): when you use the TEWA MOTO app, <b>we
            may collect your local information. For example, we might collect your IP address, country code, and city
            code.</b>
        </div>
        <div>• log information: information related to your use of our equipment. For example, the network request
          information, crash information, standard system log, and other anonymous identifier technologies of TEWA MOTO
          app.</div>
        <div>• feedback: we will collect feedback after product sales. Feedback information will include photos, text,
          contact information, application version, mobile type (IOS or Android), feedback time, etc.</div>
        <div>
          <b>With your explicit consent in advance, we may use the content you share, publish and comment on (including
            but not limited to text, photos, videos, etc.; hereinafter referred to as "content") to promote the products
            of TEWA MOTO. TikTok's official publicity channels will be applied only if you have agreed in advance,
            including, but not limited to, micro-blog, WeChat, TEWA MOTO official website, and other social
            application. </b>
          If you withdraw your consent and no longer want us to use your content, you can send an email to
          privacy@imscv.com, we will no longer use your content for promotion.
        </div>
        <div>We guarantee that we will de-identify or anonymize the collected user information according to law.
          Information that cannot identify the personal identity of natural persons alone or in combination with other
          information does not belong to personal information in the legal sense. If we combine non-personal information
          with other information to identify your personal identity or use it with your personal information, we will
          treat and protect such information as your personal information under this Privacy Policy during the combined
          use.</div>
        <div>To better operate and improve our technology and services, or due to changes in business strategies, when
          the collection, use, and processing of user information required by our products or services exceed the above
          scope, or when we want to use the collected user information for other purposes not specified in this privacy
          policy, or when we want to use the information collected for specific purposes for other purposes, We will
          notify you within a reasonable period after obtaining user information or before processing user information,
          and obtain your authorization and consent.</div>
        <div>（2） Exceptions with authorized consent</div>
        <div>Please understand that according to laws, regulations, and relevant national standards, we do not need your
          authorization to collect and use your user information under the following circumstances:</div>
        <div>1. Directly related to national security and national defense security;</div>
        <div>2. Directly related to public safety, public health, and major public interests;</div>
        <div>3. Directly related to the criminal investigation, prosecution, trial, and judgment execution;</div>
        <div>4. To safeguard your or other personal life, property, and other major legitimate rights and interests, but
          it is difficult to obtain my consent;</div>
        <div>5. Your user information collected is disclosed to the public by yourself;</div>
        <div>6. Your user information collected from legally publicly disclosed information, such as legal news reports,
          government information disclosure, and other channels;</div>
        <div>7. Necessary for signing or performing the contract according to your requirements;</div>
        <div>8. Necessary for maintaining the safe and stable operation of software and related services, such as
          finding and handling faults of software and related services;</div>
        <div>9. The personal information controller is a news unit and is necessary for carrying out legal news
          reporting;</div>
        <div>10. When it is necessary for an academic research institution to carry out statistics or academic research
          based on the public interest and provide the results of academic research or description to the outside, it
          de-identifies the personal information contained in the results.</div>
        <div>11. Other circumstances stipulated by laws and regulations.</div>
        <div>（3）Google Service</div>
        <div>If you log in to TEWA MOTO with Google OAuth service, we guarantee that when (the application) uses
          information received from the Google API and transmits it to any other application, including our application
          accessing, using, storing or sharing Google user data In this way, it will strictly abide by Google's official
          Google APIs Terms of Service and Google API Services User Data Policy and other related policies and limited
          use requirements.</div>
        <div><b>Ⅱ. How do we use Cookie and similar technologies</b></div>
        <div>（1）Cookie</div>
        <div>To ensure the normal operation of the website, we will store a small data file named cookie on your
          computer or mobile device. Cookies usually contain identifiers, site names, and numbers and characters. With
          cookies, websites can store your access preference data.</div>
        <div>We will not use cookies for any purpose other than those stated in this policy. You can manage or delete
          cookies according to your preferences. You can clear all cookies saved on your computer. Most web browsers
          have the function of blocking cookies. However, if you do, you will need to change the user settings each time
          you visit our website.</div>
        <div>（2）Website beacons and pixel tags</div>
        <div> In addition to cookies, we will also use other similar technologies such as website beacons and pixel
          labels on the website. For example, the email we send you may contain a click URL that links to the content of
          our website.</div>
        <div>If you click this link, we will track this click to help us understand your product or service preferences
          and improve customer service. A website beacon is usually a transparent image embedded in a website or e-mail.
          With the help of pixel labels in e-mail, we can know whether the e-mail is opened or not. If you don't want
          your activities to be tracked in this way, you can unsubscribe from our mailing list at any time.</div>
        <div>（3）Do not track</div>
        <div>Many web browsers are equipped with do not track function, which can publish do not track requests to
          websites. At present, the major Internet standards organizations have not established relevant policies to
          specify how websites should respond to such requests. However, if your browser enables do not track, all our
          websites will respect your choice.</div>
        <div><b>Ⅲ. How do we share, transfer and publicly disclose your user information</b></div>
        <div>（1）Share</div>
        <div>We will not share your user information with any other companies, organizations, and individuals, except
          for the following cases:</div>
        <div>1. Share with explicit consent: After obtaining your explicit consent, we will share your user information
          with other parties.</div>
        <div>2. We may share your user information by laws and regulations or the mandatory requirements of the
          competent government departments.</div>
        <div>3. Share with our affiliates: your user information may be shared with our affiliates. We will only share
          necessary user information and are bound by the purposes stated in this privacy policy. If the affiliated
          company wants to change the processing purpose of user information, it will ask for your authorization consent
          again.</div>
        <div>4. Share with authorized partners: some of our services will be provided by authorized partners only for
          the purposes stated in this policy. We may share some of your user information with our partners to provide
          better customer service and user experience. We will only share your user information for legal, legitimate,
          necessary, specific, and clear purposes, and only share the user information necessary to provide services. To
          better operate and improve technology and services, you agree that we and authorized partners can use the
          collected information for other services and purposes on the premise of complying with relevant laws and
          regulations.</div>
        <div>The following lists the specifically authorized partners and provides a link to the third party's privacy
          policy. We recommend that you read the third party's privacy policy:</div>
        <div>(a) Tencent Bugly crash statistics service, View privacy policy</div>
        <div>(b) Baidu mobile Statistics Service: View privacy policy</div>
        <div>(c) Baidu map service: View privacy policy</div>
        <div>(d) Mob social sharing service: View privacy policy</div>
        <div>For companies, organizations, and individuals with whom we share user information, we will sign a strict
          confidentiality agreement and require them to handle user information under our instructions, this Privacy
          Policy, and any other relevant confidentiality and security measures.</div>
        <div>（2）Transfer</div>
        <div>We will not transfer your user information to any company, organization, or individual, except for the
          following circumstances:</div>
        <div>(a). Transfer with explicit consent: After obtaining your explicit consent, we will transfer your user
          information to other parties;</div>
        <div>(b). In case of merger, acquisition, or bankruptcy liquidation, if the transfer of user information is
          involved, we will require the new company and organization holding your user information to continue to be
          bound by this privacy policy, otherwise, we will require the company and organization to ask you for
          authorization and consent again.</div>
        <div>（3） Public disclosure</div>
        <div>We will only publicly disclose your user information under the following circumstances:</div>
        <div>1. With your express consent;</div>
        <div>2. Law-based disclosure: we may publicly disclose your user information under the mandatory requirements of
          laws, legal procedures, litigation or government authorities.</div>
        <div>（4） Exceptions to prior authorization and consent for information sharing, transfer, and public disclosure
        </div>
        <div>Please understand that according to laws, regulations, and relevant national standards, we do not need your
          authorization to share, transfer and publicly disclose your user information under the following
          circumstances:</div>
        <div>1. Directly related to national security and national defense security;</div>
        <div>2. Directly related to public safety, public health, and major public interests;</div>
        <div>3. Directly related to the criminal investigation, prosecution, trial, and judgment execution;</div>
        <div>4. To safeguard your or other personal life, property and other major legitimate rights and interests, but
          it is difficult to obtain my consent;</div>
        <div>5. Information you disclose to the public by yourself;</div>
        <div>6. Collected from legally publicly disclosed information, such as legal news reports, government
          information disclosure and other channels.</div>
        <div><b>Ⅳ. How do we protect your user information</b></div>
        <div>（1）We have used industry-standard security measures to protect the user information provided by you from
          unauthorized access, public disclosure, use, modification, damage, or loss. We will take all reasonable and
          feasible measures to protect your user information. For example, it is protected by SSL encryption when
          exchanging data between your browser and the service; We also provide HTTPS Safe Browsing mode for the
          website; We will use encryption technology to ensure the confidentiality of data; We will use trusted
          protection mechanisms to prevent malicious attacks on data; We will deploy an access control mechanism to
          ensure that only authorized personnel can access user information; we will hold security and privacy
          protection training courses to enhance employees' awareness of the importance of protecting users'
          information.
        </div>
        <div>（2）We will take all reasonable and feasible measures to ensure that irrelevant user information is not
          collected. We will only retain your user information for the period required to achieve the purpose stated in
          the cost policy unless the retention period needs to be extended or permitted by law.</div>
        <div>（3）The Internet is not an secure environment, and e-mail, instant messaging, and communication with other
          users are not encrypted. We strongly recommend that you do not send user information through such methods.
        </div>
        <div>（4）The Internet environment is not 100% secure. We will try our best to ensure the security of any
          information you send us. Even if we have made great efforts and taken all reasonable and necessary measures,
          it may still be impossible to prevent your user information from being illegally accessed, illegally stolen,
          illegally tampered with, or destroyed, resulting in damage to your legitimate rights and interests. Please
          understand the above risks of the information network and voluntarily bear them.</div>
        <div>（5）After the unfortunate user information security incident, we will timely inform you of the basic
          situation and possible impact of the security incident, the disposal measures we have taken or will take, the
          suggestions you can independently prevent and reduce the risk, and the remedial measures for you under the
          requirements of laws and regulations. We will timely inform you of the relevant information of the event by
          mail, letter, telephone, push notification, etc. when it is difficult to inform the user information subject
          one by one, we will take a reasonable and effective way to publish the announcement. At the same time, we will
          also actively report the disposal of user information security events under the requirements of regulatory
          authorities.</div>
        <div><b>Ⅴ.Your rights</b></div>
        <div>By the relevant laws, regulations, and standards of China and the common practices of other countries and
          regions, we guarantee that you exercise the following rights to your user information:</div>
        <div>（1）Access your user information</div>
        <div>You have the right to access your user information, except for exceptions provided by laws and regulations.
          You can access your user information by yourself in the TEWA MOTO app.</div>
        <div>If you cannot access this user information in the above way, you can send an email to at any time
          privacy@imscv.com Contact us. We will reply to your visit request within 30 days.</div>
        <div>For other user information generated during your use of our products or services, we will provide it to you
          as long as we do not need too much investment. If you want to exercise data access, please email
          privacy@imscv.com。</div>
        <div>（2）Correct your user information</div>
        <div>When you find that there are errors in your user information processed by us, you have the right to ask us
          to make corrections. You can apply for correction by means listed in "(I) access your user information". If
          you cannot correct this user information through the above link, you can send an email to at any time
          privacy@imscv.com Contact us. We will reply to your request for correction within 30 days.</div>
        <div>（3）Delete your user information</div>
        <div>You can request us to delete user information in the following cases:</div>
        <div>1. If our handling of user information violates laws and regulations;</div>
        <div>2. If we collect and use your user information without your consent;</div>
        <div>3. If our handling of user information violates the agreement with you;</div>
        <div>4. If you no longer use our products or services, or you cancel your account;</div>
        <div>5. If we no longer provide you with products or services.</div>
        <div>We will evaluate your deletion request. If the corresponding provisions are met, we will take corresponding
          steps to deal with it. When you make a deletion request to us, we may require you to authenticate to ensure
          the security of your account. After you delete information from our service, due to applicable laws and
          security technologies, we may not immediately delete the corresponding information from the backup system. We
          will safely store your information until the backup can be cleared or anonymous.</div>
        <div>（4）User information subject cancels the account</div>
        <div>You can cancel the previously registered account at any time. You can send us an email to service@imscv.com
          to request delete your account, you need to indicate your TEWA MOTO account user name and registration email
          address or mobile phone number in the email, we will handle your request within 10 working days.</div>
        <div>After canceling the account, we will stop providing you with products or services and delete or anonymize
          your information according to your requirements, unless otherwise stipulated by laws and regulations. This may
          also cause you to lose access to the data in your account. Please be careful.</div>
        <div>（5）In response to your above request</div>
        <div>For security, you may need to provide a written request or otherwise prove your identity. We may ask you to
          verify your identity before processing your request.</div>
        <div>In principle, we will not charge for your reasonable request, but we will charge a certain cost for
          repeated requests that exceed the reasonable limit according to the situation. We may refuse unreasonably
          repetitive requests, require too many technical means (for example, need to develop new systems or
          fundamentally change existing practices), pose risks to the legitimate rights and interests of others, or are
          very impractical. Please also understand that we may not be able to respond to some of your requests due to
          security considerations, requirements of relevant laws and regulations, or technical restrictions, such as the
          following situations:</div>
        <div>1. Related to the user information controller's performance of obligations stipulated by laws and
          regulations;</div>
        <div>2. Directly related to national security and national defense security;</div>
        <div>3. Directly related to public safety, public health, and major public interests;</div>
        <div>4. Directly related to the criminal investigation, prosecution, trial, and execution of judgment;</div>
        <div>5. The user information controller has sufficient evidence to show that the user information subject has
          subjective malice or abuse of rights;</div>
        <div>6. To safeguard the life, property, and other major legitimate rights and interests of the user information
          subject or other individuals, but it is difficult to obtain my consent;</div>
        <div>7. Responding to the request of the user information subject will cause serious damage to the legitimate
          rights and interests of the user information subject or other individuals and organizations;</div>
        <div>8. Involving trade secrets.</div>
        <div><b>Ⅵ. How do we handle children's personal information</b></div>
        <div>We attach great importance to the protection of children's personal information. Our products, websites,
          and services are mainly for adults. Children should not create their user accounts without the consent of
          their parents or guardians. Although local laws and customs define children differently, we regard anyone
          under the age of 14 as a child.</div>
        <div>For the collection of child user information with the consent of parents or guardians, we will only store,
          use or publicly disclose this information when permitted by law, explicitly agreed by parents or guardians, or
          necessary to protect children, otherwise, we will try to delete relevant data as soon as possible.</div>
        <div>Because of the limitations of the existing technology and business model, it is difficult for us to
          actively identify the children's personal information. If you find that we have collected the children's
          personal information without our knowledge or the prior consent of a verifiable guardian, you can contact us
          in time, and we will try to delete it in time after discovery. If we find the above situation ourselves, We
          will also delete it in time, except for what the law requires us to keep.</div>
        <div><b>Ⅶ. How is your user information stored and transferred globally</b></div>
        <div>In principle, the user information we collect and generate in the people's Republic of China will be stored
          in the people's Republic of China. We will only retain your user information within the period required for
          the purpose and purpose described in this policy and the shortest period specified by laws and regulations.
          After exceeding the above retention period, we will delete your user information or anonymize it according to
          the requirements of applicable laws and regulations. Unless otherwise provided by laws and regulations, or for
          public interest, scientific and historical research, or otherwise authorized and agreed by you, we may need to
          retain relevant data for a long time.</div>
        <div>Because we provide products or services through resources and servers all over the world, it means that
          after obtaining your authorization and consent, your user information may be transferred to or accessed from
          overseas jurisdictions in the countries/regions where you use the products or services.</div>
        <div>Such jurisdictions may have different data protection laws or even no relevant laws. In such cases, we will
          ensure that your user information is adequately and equally protected in the people's Republic of China. For
          example, we will request your consent to the cross-border transfer of user information, or implement security
          measures such as data De-identification before cross-border data transfer.</div>
        <div><b>Ⅷ. How is this policy updated</b></div>
        <div>Our privacy policy may change. Without your express consent, we will not reduce your rights under this
          privacy policy. We will post any changes to this policy on this page.</div>
        <div>For major changes, we will also provide more significant notice. Major changes referred to in this policy
          include but are not limited to:</div>
        <div>1. Significant changes have taken place in our service model. Such as the purpose of processing user
          information, the type of user information processed, the use mode of user information, etc;</div>
        <div>2. We have undergone significant changes in ownership structure, organizational structure, etc. Such as
          owner change caused by business adjustment, bankruptcy, M & A, etc;</div>
        <div>3. The main objects of user information sharing, transfer, or public disclosure have changed;</div>
        <div>4. Significant changes have taken place in your right to participate in user information processing and how
          you exercise it;</div>
        <div>5. We are responsible for handling changes in the responsible department, contact information, and
          complaint channels of user information security;</div>
        <div>6. When the user information security impact assessment report indicates that there is a high risk.</div>
        <div>We will also archive older versions of this policy for your reference.</div>
        <div><b>Ⅸ. How to contact us</b></div>
        <div>If you have any questions, comments, or suggestions about this privacy policy, please contact us through
          the following ways:</div>
        <div>E-mail: privacy@tewamoto.com</div>
      </div>
      <div class="txt" v-if="active==2"></div>
    </div>
    <footer-page></footer-page>
  </div>
</template>

<script>
  import navTab from '@/components/navTab'
  import footerPage from '@/components/footer'
  export default {
    name: 'Privacy',
    components: { footerPage, navTab },
    data () {
      return {
        active: 0,
        name: 'Terms & Conditions',
        tabList: [
          { title: 'Terms & Conditions' },
          { title: 'Privacy Policy' },
          // { title: 'Cookie Policy' }
        ],
        navBarList: [
          { name: 'HOME', path: '/home' },
          { name: 'M3 SERIES', path: '/M3SERIES' },
          { name: 'UPCOMING PRODUCTS', path: '/newProduct' },
          { name: 'ABOUT', path: '/about' },
          { name: 'DEALER NETWORK', path: '/contact' },
        ]

      }
    },
    mounted () {
      this.active = this.$route.query.type;
      window.scrollTo(0, 0)
    },
    methods: {
      LinkFn (path) {
        this.$router.push(path)
      },
      changeFn (index) {
        this.active = index;
      }
    }
  }
</script>

<style scoped lang="scss">
  @media (max-width: 768px) {
    .privacy {
      width: 100vw;
      overflow: hidden;

      .header {
        display: flex;
        align-items: center;
        column-gap: 25px;
        background: #000;
        color: #fff;
        padding: 16px;
      }

      .content {
        padding: 20px 16px;

        .tabBar {
          display: flex;
          font-family: Tilt Warp;

          div {
            padding: 4px 12px;
            border: 1px solid #000;
            box-sizing: border-box;
            font-size: 12px;
          }

          .active {
            color: #fff;
            background-color: #000;
          }
        }

        .txt {
          padding: 8px 12px;
          box-sizing: border-box;
          border: 1px solid #000;
          line-height: 15px;
          font-size: 10px;

          b {
            font-size: 12px;
          }

          div {
            margin-bottom: 8px;
          }
        }
      }
    }
  }

  @media (min-width: 769px) {
    .privacy {
      width: 100%;
      overflow: hidden;

      .header {
        display: flex;
        column-gap: 25px;
        /* PC 宽屏：导航内容压在 1440px 内居中 */
        padding: 32px max(57px, calc((100% - 1440px) / 2));
        background: #000;
        font-size: 16.66px;
        color: #fff;
        font-family: Tilt Warp;

        div {
          cursor: pointer;
        }
      }

      .content {
        /* PC 宽屏：条款内容压在 1440px 内居中，避免一行过长 */
        padding: 32px max(57px, calc((100% - 1440px) / 2));

        .tabBar {
          display: flex;
          font-size: 19.44px;
          font-family: Tilt Warp;

          div {
            padding: 11.12px 22.22px;
            border: 1px solid #000;
            box-sizing: border-box;
            cursor: pointer;
          }

          .active {
            color: #fff;
            background: #000;
          }
        }

        .txt {
          padding: 16.66px;
          box-sizing: border-box;
          line-height: 20.38px;
          font-size: 13.88px;
          border: 1px solid #000;

          b {
            font-size: 16.66px;
          }

          div {
            margin-bottom: 10.41px;
          }
        }
      }
    }
  }
</style>